import { useEffect } from "react"

import { Button, Form } from "@/atoms"
import { LAST_SUCCESS_SLUG_LOG_IN } from "@/const/local-storage.constants"
import { getSlugSelfHosted, isSelfHosted } from "@/helpers/self-hosted.helper"
import { toLowerCase } from "@/helpers/string.helpers"
import { useSlugSignInRedirect } from "@/hooks/useSlugSignInRedirect"
import { useTranslation } from "@/hooks/useTranslation"
import { SlugInputFormItem } from "@/molecules/SlugInputFormItem"

import styles from "./OrganizationSlugForm.module.scss"

export const OrganizationSlugForm = () => {
  const { t } = useTranslation()
  const navigate = useSlugSignInRedirect()

  const onFinish = (value?: { slug: string }) => {
    const { slug } = value || {}

    if (slug) navigate(toLowerCase(slug))
  }

  const selfHosted = isSelfHosted()

  useEffect(() => {
    const selfHostedSlug = getSlugSelfHosted()

    if (selfHosted && selfHostedSlug) onFinish({ slug: selfHostedSlug })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (selfHosted) return null

  return (
    <Form
      id="slug-form"
      name="slugForm"
      initialValues={{
        remember: true,
        slug: localStorage.getItem(LAST_SUCCESS_SLUG_LOG_IN)
      }}
      onFinish={onFinish}
      layout="vertical"
      requiredMark={false}
    >
      <SlugInputFormItem name="slug" size="large" />
      <Form.Item className={styles.buttonFormItem}>
        <Button
          block
          type="ks"
          htmlType="submit"
          size="large"
          data-testid="submit_slugForm"
        >
          {t("general.continue")}
        </Button>
      </Form.Item>
    </Form>
  )
}
